import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import { CusFormLabel} from '../validation/Form-Components';
import service from '../services/StatusEnquiryApiService';
import Loading from '../components/Loading';
import helper from '../factory/Helper';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import config from '../appconfig/config.json';
import CusSavePrint from '../components/CusSavePrint';
import CusGreenBtn from '../components/CusGreenBtn';
import storage from '../factory/StorageFactory.js';
import UploadStatus from '../hybridcomponents/UploadStatus.jsx';
import aipImgAPN from '../hybridImages/AIPStatusComplete.png';
import losData from '../hybriddata/loanstatusdata.json';
import nldata from '../hybriddata/nonlendingdata.json';
import aipImgLAP from '../hybridImages/AIPStatusLAP.png';
import aipImgAHB from '../hybridImages/appStatusLOPending.png';

const AIPStatusInfoDetails = (props) => {

    const [refNo, setRefNo] = useState('');
    const [uen,setUEN] = useState('');

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [response, setResponse] = useState();
    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);


    useEffect(() => {
        console.log('@AIPStatusInfoDetails useEffect');
   
        window.scrollTo(0, 0);
        getStatusEnquiry();
        //clearData();
    }, []);

    const getStatusEnquiry = () => {

        const sid = storage.getStateId();
        const rno = storage.getRefNo();

        service.getStatusEnquiry(sid,rno).then( res => {
            
            let resData = res.data.model.fields.request;
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
            setIsLoading(false);
        })
        .catch( err => {
            console.log('getStatus err: ',err);
            setIsLoading(false);
            props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
        })
    }

  
    //export and print pdf
    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 5,
            fileName: response.StatusDtls.ApplicationNo + '.pdf',
            proxyUrl: getProxyUrl()
        });
    };

    const printPDF = () => {
        window.print();
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('NSStatusDetails');
        return url;
    }
 

    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
     
    }
 
    const getStatusData = () => {
        setIsLoading(true);
        const sid = storage.getStateId();
        const rno = storage.getRefNo();
        service.getStatus(sid, rno).then(res => {
            let resData = res.data.model.fields.request;
         
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
 
          
            setIsLoading(false);
        })
        .catch(err => {
            console.log('err: ', err);
            setIsLoading(false);
        })
    }

    const isProductAIP = () => {
   
        if(response.StatusDtls.ProductType === config.bizFinancing.AIP) {
            return true;
        }

        return false;
    }
 
    const isPureAIP = () => {
        if(isProductAIP() && response.StatusDtls.isExistingOTPAvailable === 'N') {
            return true;
        }
            
        return false;
    }

    const getNonLendingString = () => {
        let result = '',temp = [];

        if(response.StatusDtls.MYCurrentAccount === 'N' && response.StatusDtls.FXDeskServices === 'N'
        && response.StatusDtls.BusinessInsurance === 'N' && response.StatusDtls.SMEStartDigital === 'N'
        && response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'N') {
            result = 'Not Applicable';
            return result;
        }

        if(response.StatusDtls.MYCurrentAccount === 'Y') {
            temp.push(nldata.product1.title);
        }
        if(response.StatusDtls.FXDeskServices === 'Y') {
            temp.push(nldata.product2.title);
        }
        if(response.StatusDtls.BusinessInsurance === 'Y'){
            temp.push(nldata.product3.title);
        }
        if(response.StatusDtls.SMEStartDigital === 'Y') {
            temp.push(nldata.product4.title);
        }
        if(response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'Y') {
            temp.push(nldata.product5.title);
        }
          
        
        if(temp.length === 1) {
            result = temp[0];
        }
        else {
            result = temp.join(', ');
        }

        return result;
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={refNo + '.pdf'}>
            <div className="container-fluid">
                <div className="outerdivsubheader">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <h2 className='completeTitle1 mb-0'>
                            {response.StatusDtls.ApplicationProgress === config.StatusDtls.LAP &&
                             <>{losData.mainTitle.LAP}</>  
                            }
                            </h2>
                        </div>
                    </div>
                </div>
                
                <FormContainer>
                    <div className='statusImgHeader'>
                        {response.StatusDtls.ApplicationProgress === config.StatusDtls.LAP &&
                        <img src={aipImgLAP} alt="aipImgLAP"></img>
                        }
                    </div>
                </FormContainer>

                <FormContainer>
                    <div style={{ textAlign: 'center', padding: '20px'}}>
                        <h2 className='status-header-txt'>
                            {response.StatusDtls.ApplicationProgress === config.StatusDtls.LAP &&
                                losData.yellowTitle.LAP
                            }
                
                        </h2>
                    </div>
              

                    <div style={{ width: '100%', marginLeft: '-10px' }}>
                        <hr className="hrgoldline" />
                    </div>
                    <div style={{ marginLeft: '25px', margingRight: '25px' }}>

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                            id={'appNum'} name={response.StatusDtls.ApplicationNo} />

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'UEN'}
                            id={'uen'} name={response.StatusDtls.UEN} />
                   
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Facility'}
                            id={'facility'} name={response.StatusDtls.Facility} />

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Financing Type'}
                            id={'financeType'} name={response.StatusDtls.FinancingType} />
            
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Amount'}
                            id={'amt'} name={helper.formatAmount(response.StatusDtls.Amount)}/>

                        <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                            id={'purpose'} name={'Property'} />

                        <CusFormLabel leftLabelId={'lblCombinedApp'} leftLabelName={'Combined Applications (Non-lending)'}
                            id={'combinedApp'} name={getNonLendingString()} />
 
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Submission Date'}
                            id={'date'} name={response.StatusDtls.AppDate} />
                     
                        <CusFormLabel leftLabelId={'lblAIPExpDate'} leftLabelName={'Approval In-Principle Expiry Date'}
                            id={'expDate'} name={response.StatusDtls.ExpiryDate !==null? helper.formatDate2(response.StatusDtls.ExpiryDate):'-'} />
                   
                        <br />
                    </div>
           
                    <CusSavePrint lb1='Save this PDF' onClick1={exportPDFWithMethod} lb2='Print this' onClick2={printPDF} />

                    <div style={{ textAlign: "center" }} >
                        <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome} />
                        <br />
                 
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <span>{losData.assitance.title}</span>&nbsp;
                                <span className='add-btn-blue'>{losData.assitance.email}</span>
                            </div>
                        </div>
                    </div>
                    <br />
                    </FormContainer>
                <br />
            </div>
        </PDFExport>
    )
}

export default AIPStatusInfoDetails;